import { Reports } from 'features/reports';
import { useTitle } from '../helpers';

/**
 * @page Reports
 */
const ReportsPage = () => {
  useTitle('Отчёты');

  return (
    <div>
      <h3>Отчёты</h3>
      <Reports />
    </div>
  );
};

export default ReportsPage;
